<script lang="ts">
  import { page } from "$app/stores";

  import clsx from "clsx";
  import type { Icon } from "lucide-svelte";

  export let to: string;
  export let icon: typeof Icon | null = null;
  export let end = false;

  $: selected =
    $page.url.pathname === to ||
    (!end && $page.url.pathname.startsWith(to + "/"));
</script>

<a
  href={to}
  class="flex items-center p-2 text-white/80 font-medium text-sm hover:bg-white/5 active:bg-white/10 rounded-lg"
  class:selected
>
  {#if icon}
    <svelte:component
      this={icon}
      size={16}
      class={clsx(
        "mr-2 flex-shrink-0",
        selected ? "text-primary" : "text-zinc-300",
      )}
    />
  {/if}
  <slot />
</a>

<style lang="postcss">
  .selected {
    @apply bg-primary/10 text-primary hover:bg-primary/10 active:bg-primary/10;
  }
</style>
